<template>
  <el-submenu v-if="hasChildren" :index="subIndex">
    <template slot="title">
      <i :class="menuIconClass" />
      <span>{{ menu.menuName }}</span>
    </template>
    <admin-menu-item v-for="child in menu.children" :key="child.id" :menu="child" />
  </el-submenu>
  <el-menu-item v-else-if="menu.path" :index="menu.path">
    <i :class="menuIconClass" />
    <span slot="title">{{ menu.menuName }}</span>
  </el-menu-item>
</template>

<script>
const ICON_MAP = {
  dashboard: 'el-icon-data-line',
  users: 'el-icon-user',
  'file-text': 'el-icon-document',
  video: 'el-icon-video-camera',
  message: 'el-icon-chat-line-square',
  coin: 'el-icon-coin',
  money: 'el-icon-wallet',
  wallet: 'el-icon-wallet',
  news: 'el-icon-reading',
  comment: 'el-icon-chat-dot-round',
  shopping: 'el-icon-shopping-bag-1',
  agent: 'el-icon-s-custom',
  invoice: 'el-icon-tickets',
  setting: 'el-icon-setting',
  system: 'el-icon-s-tools',
  // menu_code 兜底（库表 icon 为空时）
  pay_orders: 'el-icon-wallet',
  points: 'el-icon-coin',
  membership_plans: 'el-icon-goods',
  membership: 'el-icon-goods'
}

export default {
  name: 'AdminMenuItem',
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasChildren() {
      return this.menu.children && this.menu.children.length > 0
    },
    subIndex() {
      return this.menu.menuCode || String(this.menu.id)
    },
    menuIconClass() {
      return this.resolveIcon(this.menu.icon, this.menu.menuCode)
    }
  },
  methods: {
    resolveIcon(icon, menuCode) {
      if (icon && ICON_MAP[icon]) return ICON_MAP[icon]
      if (icon && String(icon).startsWith('el-icon-')) return icon
      if (menuCode && ICON_MAP[menuCode]) return ICON_MAP[menuCode]
      if (icon) return 'el-icon-menu'
      return 'el-icon-menu'
    }
  }
}
</script>
